class VirtualMachine {
    constructor() {}

    static getSearchKey() {
        return 'name';
    }

    static getResourceGroupsKey() {
        return 'resourceGroup_name';
    }

    static getStatusKey() {
        return 'protection';
    }

    static getCompliancyKey() {
        return 'compliancy';
    }

    static getCredentialsKey() {
        return 'credential_name';
    }

    static getOwnerKey() {
        return 'ownerUsername';
    }

    static getPolicyKey() {
        return 'policy_name';
    }

    static getDiscoveryKey() {
        return 'discoveryStatus';
    }

    static getStatusOptions() {
        return [
            { label: 'Yes', value: 'PROTECTED' },
            { label: 'No', value: 'UNPROTECTED' },
            { label: 'Deleted', value: 'PROTECTED_DELETED' },
        ];
    }

    static getCompliancyOptions() {
        return [
            { label: 'Success', value: 'GREEN' },
            { label: 'Failure', value: 'RED' },
            { label: 'Undefined', value: 'GREY' },
        ];
    }

    static getDiscoveryOptions() {
        return [
            { label: 'Success', value: 'OK' },
            { label: 'Failure', value: 'ERROR' },
            { label: 'Warning', value: 'WARNING' },
            { label: 'Undefined', value: 'UNDEFINED' },
        ];
    }

    static getClusterKey() {
        return 'subscriptionName';
    }

    static fromRaw(raw) {
        let virtualMachine = new VirtualMachine();
        virtualMachine.virtualMachine = true;
        virtualMachine.uuid = `${raw.uuid}`;
        virtualMachine.consistencyGroupName = raw.consistencyGroupName;
        virtualMachine.diskCapacityInBytes = raw.diskCapacityInBytes;
        virtualMachine.externalId = raw.externalId;
        virtualMachine.externalHypervisorName = raw.subscriptionName;
        virtualMachine.externalHypervisorId = raw.subscriptionId;
        virtualMachine.hycuVm = raw.hycuVm;
        virtualMachine.memoryCapacityInBytes = raw.memoryCapacityInBytes;
        virtualMachine.compliancy = raw.compliancy;
        virtualMachine.discoveryStatus = raw.discoveryStatus;
        virtualMachine.discoveryMessage = raw.discoveryMessage;
        virtualMachine.numNetworkAdapters = raw.numNetworkAdapters;
        virtualMachine.numVCpus = raw.numVCpus;
        virtualMachine.ostype = raw.operatingSystem;
        virtualMachine.name = raw.name;
        virtualMachine.location = raw.location;
        virtualMachine.taskStatus = raw.taskStatus;
        virtualMachine.policy = raw.policy;
        virtualMachine.subnets = raw.subnets;
        virtualMachine.resourceGroup = raw.resourceGroup;
        virtualMachine.protectionGroupUuid = raw.policyId;
        virtualMachine.protection = raw.protection;
        virtualMachine.credential = raw.credential;
        virtualMachine.credentialGroupUuid = raw.credentialId;
        virtualMachine.hypervisorUuid = raw.hypervisorUuid;
        virtualMachine.diskCount = raw.diskCount;
        virtualMachine.machineType = raw.sizeAzure;
        virtualMachine.lastSuccessfulBackup = raw.timeSinceLastSuccessfulBackup;
        virtualMachine.backupSuccessRate = raw.backupSuccessRate;
        virtualMachine.policyCompliancySuccessRate = raw.policyCompliancySuccessRate;
        virtualMachine.policyAssignorEmail = raw.policyAssignorEmail;
        virtualMachine.managed = raw.managed;
        virtualMachine.policyAssignedFromTags = raw.policyAssignedFromTags;
        virtualMachine.hycuRestoreUuid = raw.hycuRestoreUuid;
        virtualMachine.disks = raw.disks;
        return virtualMachine;
    }
}
module.exports = VirtualMachine;



// WEBPACK FOOTER //
// ./src/azurebackup/model/VirtualMachine.js